import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dcd4a1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "score-portion" }
const _hoisted_2 = { class: "vertical" }
const _hoisted_3 = { class: "score-title" }
const _hoisted_4 = { class: "score-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.scoreTitle), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.score), 1)
    ])
  ]))
}